import { loggerFacet, ClientId } from '../facets/LoggerFacets';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { readConfiguration } from './configuration/readConfiguration';

/**
 * Extracts sharing client id from the configuration.
 * @internal
 */
export function getSharingClientId(): IItemCacheThunkAction<string> {
    return (dispatch: IItemCacheDispatch) => {
        const {
            logger
        } = dispatch(readConfiguration({
            logger: loggerFacet
        }));

        if (logger && logger.sharingClientId) {
            return ClientId[logger.sharingClientId];
        }

        // If host did not provide sharingClientId, default to unknown
        return ClientId[ClientId.unknown];
    };
}
